/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/QaLockedAreaBanner.tsx
 * FILE_ID: JOBHUB-QA-LOCKED-BANNER-001
 * PURPOSE: Explain a locked area and offer Unlock when the user can sign off.
 */
import { Loader2, Lock } from 'lucide-react'
import type { QaAreaExecution } from '../../qa/qaTypes'

export function QaLockedAreaBanner({
  area,
  unlocking = false,
  onUnlock,
}: {
  area: QaAreaExecution
  unlocking?: boolean
  onUnlock?: () => void
}) {
  const who = area.locked_by_name?.trim() || 'someone'
  const when = area.locked_at
    ? new Date(area.locked_at).toLocaleString()
    : ''
  const reason = area.lock_reason?.trim()
  return (
    <div
      role="status"
      data-testid="qa-locked-banner"
      className="flex flex-wrap items-start justify-between gap-2 rounded-lg border border-amber-400/40 bg-amber-500/10 px-3 py-2 text-xs text-foreground"
    >
      <div className="flex min-w-0 items-start gap-2">
        <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-700" aria-hidden />
        <p>
          This area was locked by {who}{when ? ` on ${when}` : ''}. Unlock it to edit.
          {reason ? <span className="mt-1 block text-muted-foreground">{reason}</span> : null}
        </p>
      </div>
      {onUnlock && (
        <button
          type="button"
          onClick={onUnlock}
          disabled={unlocking}
          className="inline-flex shrink-0 items-center gap-1 rounded-md border border-border bg-card px-2 py-1 text-xs font-medium"
        >
          {unlocking ? <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden /> : null}
          Unlock
        </button>
      )}
    </div>
  )
}
